import { render } from "./powerComponent.vue?vue&type=template&id=7dd4a526"
import script from "./powerComponent.vue?vue&type=script&lang=js"
export * from "./powerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__